export const LAST_ACTIVITY_STORAGE_KEY = "lastActivity";
export const INACTIVITY_WARNING_MS = 5 * 60 * 1000;
export const INACTIVITY_TIMEOUT_MS = 15 * 60 * 1000;

export type LastActivityGate = "ok" | "stale";

export function readLastActivityMs(): number | null {
  const raw = localStorage.getItem(LAST_ACTIVITY_STORAGE_KEY);
  const parsed = raw != null ? Number(raw) : NaN;
  return Number.isFinite(parsed) ? parsed : null;
}

export function writeLastActivityMs(ms: number): void {
  localStorage.setItem(LAST_ACTIVITY_STORAGE_KEY, String(ms));
}

export function ensureLastActivitySeed(nowMs: number = Date.now()): number {
  const existing = readLastActivityMs();
  if (existing != null) return existing;
  writeLastActivityMs(nowMs);
  return nowMs;
}

export function touchLastActivity(nowMs: number = Date.now()): void {
  writeLastActivityMs(nowMs);
}

export function gateByLastActivity(
  nowMs: number = Date.now(),
): LastActivityGate {
  const last = ensureLastActivitySeed(nowMs);
  if (nowMs - last > INACTIVITY_TIMEOUT_MS) {
    return "stale";
  }

  return "ok";
}

export function msUntilInactivityLogout(nowMs: number = Date.now()): number {
  const lastActivity = ensureLastActivitySeed(nowMs);
  return INACTIVITY_TIMEOUT_MS - (nowMs - lastActivity);
}
